export default __webpack_public_path__ + "assets/apple-touch-icon-180x180-90f3747.png";